<template>
    <vSelect
        :id="_uid"
        :placeholder="placeholderText"
        :autoscroll="true"
        :label="label"
        :options="options"
        :value="value"
        :name="name"
        :ref="_uid"
        :key="name"
        :inputId="name + '.Input'"
        :disabled="disabled"
        :reduce="reduce"
        :clearable="clearable"
        :selectOnTab="true"
        :v-model="selectedValue"
        class="vSelect-dynamic-width"
        @input="$emit('input', $event)"
        v-bind="attributes"
        @close="close"
    >

      <template #option="{ label1, label2 }">
        <div style="flex: 1; flex-direction: column;">
          <p style="margin: 0">{{label1}}</p>
          <p style="margin: 0">{{ label2 }}</p>
        </div>
      </template>
      
    </vSelect>
</template>
<script>
  import vSelect from 'vue-select';
  export default {
      props: {
          value: { default: '' },
          name: { type: String },
          placeholder: { type: String, required: true },
          label: { type: String, default: 'label' },
          options: { required: true, type: Array },
          disabled: { default: false },
          clearable: { default: true },
          dynamicWidth: { type: Boolean, required: true },
          filter: { type: Function, default: null },
          reduce: {
              type: Function,
              default: (option) => option,
          },
      },
      data() {
          return {
              selectedValue: null,
          };
      },
      components: {
          vSelect,
      },

      watch: {
          options: {
              handler() {
                  this.setStyle();
              },
          },
          value:{
            handler(){
              this.$refs[this._uid]._data.typeAheadPointer = -1;
            }
          }
      },

      mounted() {
          this.setStyle();
        
      },

      computed: {
          attributes() {
              if (this.filter !== null) {
                  return { filter: this.filter };
              } else {
                  return {};
              }
          },
          placeholderText() {
              if (this.options.length > 0) {
                  return this.placeholder;
              }
              return this.$t('core.loading');
          },

          getWidth() {
              let _self = this;

              if (this.options.length == 0) {
                  return 0;
              }

              let longestCharacterLength = this.getOptionLabel(
                  this.options.reduce(function (a, b) {
                      let aLength = _self.getOptionLabel(a).length;
                      let bLength = _self.getOptionLabel(b).length;
                      return aLength > bLength ? a : b;
                  })
              ).length;

              const pixelWidth = 7.8; //approx pixel length per character

              const vSelectWidth = longestCharacterLength * pixelWidth;

              return vSelectWidth;
          },
      },
      methods: {
          close(){
            let self = this;
            let index = this.options.findIndex((el) => {
              return self.reduce(el) === self.selectedValue;
            })
            this.$refs[this._uid].$data.typeAheadPointer = index;
          },
          update(event) {},

          getOptionLabel(option) {
              if (typeof option === 'object') {
                  return option[this.label];
              }
              return option;
          },

          setStyle() {
              if (this.dynamicWidth) {
                  let element = document.getElementById(this._uid);
                  let ul = element.getElementsByTagName('ul');

                  let minimumWidth = this.$refs[this._uid].$el.clientWidth;
                  let width = this.getWidth;

                  //Sets the minimum width
                  ul[0].style.minWidth = minimumWidth + 'px';

                  //If the width is larger, set the new width
                  if (width > minimumWidth) {
                      ul[0].style.width = width + 'px';
                  }

                  //Set the width to the minimum width
                  else {
                      ul[0].style.width = minimumWidth + 'px';
                  }
              }
          },
      },
  };
</script>

<style>
  .vs__selected-options {
      width: 129px;
      overflow: hidden;
      white-space: nowrap;
      flex-wrap: nowrap !important;
  }
  .v-select ul {
      min-width: max-content !important; /*or some other pixel value < 160*/
  }
</style>
